import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from '@mui/material'

import { unit } from '../../../utils'

export const IconFixedSize = styled(FontAwesomeIcon)`
  height: ${unit(5)};
  width: ${unit(4)};
`
